import React, { Component } from "react";
import { connect } from "react-redux";
import { updatePreviewData } from "Store/ZoneSetting/action";
import { createPage } from "nc-lightapp-front";
import Ajax from 'Pub/js/ajax';
import { langCheck } from "Pub/js/utils";
import { getMulti } from "Pub/js/getMulti";
import HotKeysModal from "Components/HotKeysModal";
import "./index.less";

//加载模板
function initTemplate(json, callback) {
    const { requestUrl, requestData, templetData } = this.props;
    const { pagecode, appcode, templetid } = templetData;
    let url = requestUrl || '/nccloud/platform/templet/querypage.do';
    let data = requestData || {
        pagecode,
        appcode,
        templetid,
    };
    if (Array.isArray(data) && data.length == 0) { return; }
    Ajax({
        url,
        data,
        loading: true,
        info: {
            name: langCheck('ZoneSetting-000028', "pages", json), /* 国际化处理： 模板*/
            action: langCheck('ZoneSetting-000029', "pages", json), /* 国际化处理： 模板预览*/
        },
        success: ({ data: { data } }) => {
            if (data) {
                this.registerComponent(data);
                for (const [k, v] of Object.entries(data)) {
                    let areaId = v.code;
                    let key = v.moduletype;
                    if (key === "form") {
                        this.props.form.setFormStatus(areaId, "add");
                    }
                }
                this.props.meta.setMeta(data);
                //增加position排序
                requestData && requestData.forEach(area => {
                    if (data[area.code]) { data[area.code].position = area.position; }
                });

                this.props.updatePreviewData(data);
                this.setState({ reRender: true }, () => callback(data));
            }
        },
    });
}

//预览模态框组件类1909版
class PreviewModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            all_keys: [],
            json: {},
            reRender: false,
        };
    }
    afterInitTemplate = previewData => {
        if (previewData) {
            let reviewData = previewData;
            let all_keys = [];
            let tabGirdRelationCode = this.getTabGirdRelationCode(reviewData);
            const { formrelation, containerrelation, formassociatedrelation } = reviewData;
            let tableTabCodesList = [], formTabCodesList = [];
            tabGirdRelationCode && Object.values(tabGirdRelationCode).forEach(item => {
                tableTabCodesList = tableTabCodesList.concat(item);
            });
            formassociatedrelation && Object.values(formassociatedrelation).forEach(item => {
                formTabCodesList = formTabCodesList.concat(item.formtabs);
            });
            for (const [k, v] of Object.entries(reviewData)) {
                if (v === undefined) { break; } // 经过setMeta之后的数据会多出 flatLayout 和 originlayout 是个undefined，做个兼容
                let key = v.moduletype;
                let areaId = v.code;
                if (key === "table" || key === "form" || key === "search") {
                    //不渲染表单分组
                    if (key === "form" && formrelation && v.relationcode in formrelation) {
                        //
                    } else if (key === 'form' && formassociatedrelation && formTabCodesList.includes(k)) { //不渲染主表页签

                    } else if (
                        containerrelation &&
                        tabGirdRelationCode &&
                        Object.values(containerrelation).length &&
                        Object.keys(tabGirdRelationCode).includes(k)
                    ) {
                        all_keys.push({
                            id: areaId,
                            name: v.name,
                            myAreaType: key,
                            position: v.position,
                            tabGirdRelationCode: tabGirdRelationCode[k],
                            srcAreaCode: k,
                            isunfold: v.isunfold
                        });
                    } else if (!tableTabCodesList.includes(k)) {
                        all_keys.push({
                            id: areaId,
                            name: v.name,
                            myAreaType: key,
                            position: v.position,
                            isunfold: v.isunfold
                        });
                    }
                }
                //表格区默认新增一行
                if (key === "table") {
                    setTimeout(() => { //为解决edittable未渲染完再增行报错
                        if (this.props.editTable.getNumberOfRows(areaId) == 0) {
                            this.props.editTable.addRow(areaId);
                        }
                    }, 10);
                }
            }
            if (all_keys[0] && all_keys[0].position) {
                all_keys.sort((a, b) => a.position - b.position); //按照position排序
            }
            //  更新state;
            this.setState({ all_keys: all_keys });
        }
    }

    //表格多页签关联编码
    getTabGirdRelationCode = sourceData => {
        let tabGirdRelationCode = {};
        for (const [key, value] of Object.entries(sourceData)) {
            //子表多页签关联关系
            if (key === 'containerrelation') {
                for (const [tabheadcode, v] of Object.entries(value)) {
                    if (tabheadcode) {
                        if (!tabGirdRelationCode.hasOwnProperty(tabheadcode)) {
                            tabGirdRelationCode[tabheadcode] = [];
                        }
                        v.map(tabCode => {
                            tabGirdRelationCode[tabheadcode] = tabGirdRelationCode[tabheadcode].concat(tabCode);
                        });
                    }
                }
            }
        }
        return tabGirdRelationCode;
    }
    //注册组件
    registerComponent = template => {
        const tabGirdRelationCode = this.getTabGirdRelationCode(template);
        const formIds = Object.values(template).filter(item => item && item.moduletype === 'form').map(item => item.code);
        let tableIds = Object.values(template).filter(item => item && item.moduletype === 'table').map(item => item.code);
        const searchIds = Object.values(template).filter(item => item && item.moduletype === 'search').map(item => item.code);
        const cardTableIds = tabGirdRelationCode && Object.keys(tabGirdRelationCode) || [];
        if (cardTableIds.length && tabGirdRelationCode) {
            Object.values(tabGirdRelationCode).forEach(tabcodes => {
                //editTable code去重
                tableIds = _.differenceBy(tableIds, tabcodes);
            });
        }
        if (formIds.length) { this.props.use.form.apply(null, formIds); }
        if (tableIds.length) { this.props.use.editTable.apply(null, tableIds); }
        if (cardTableIds.length) { this.props.use.cardTable.apply(null, cardTableIds); }
        if (searchIds.length) { this.props.use.search.apply(null, searchIds); }
    }

    //隐藏预览模态框
    showModalHidden = () => {
        this.props.setModalVisibel(false);
    };
    //创建预览内容的DOM结构
    createDom = () => {
        let { editTable, form, search, cardTable } = this.props;
        let { createForm } = form;
        let { createEditTable } = editTable;
        let { NCCreateSearch } = search;
        let { createCardTable } = cardTable;
        let { all_keys } = this.state;
        let result = [];
        // 所有预览
        if (all_keys.length) {
            all_keys.forEach((val, i) => {
                const commonProperties = {
                    myAreaType: val.myAreaType,
                    id: val.id,
                    name: val.name,
                    isunfold: val.isunfold
                };
                switch (val.myAreaType) {
                    case "form":
                        result.push({
                            ...commonProperties,
                            children: createForm(val.id)
                        });
                        break;
                    case "table":
                        if (val.tabGirdRelationCode) {
                            result.push({
                                ...commonProperties,
                                children: createCardTable(val.srcAreaCode, { cancelCustomRightMenu: true })
                            });
                        } else {
                            result.push({
                                ...commonProperties,
                                children: createEditTable(val.id, {
                                    cancelCustomRightMenu: true, //禁用列设置
                                })
                            });
                        }
                        break;
                    case "search":
                        result.push({
                            ...commonProperties,
                            children: NCCreateSearch(val.id, { useCache: false })
                        });
                        break;
                    default:
                        break;
                }
            });
        }
        return result.map((item, i) => <div
            className="viewTemplateArea"
            key={`${item.myAreaType}${i}`}
            ref={`${item.id}`}
        >
            <div className="descrip" onClick={() => {
                all_keys[i].isunfold = !all_keys[i].isunfold;
                this.setState({
                    all_keys
                })
            }}>
                <span className={`arrow ${item.isunfold ? '' : 'fold'}`} key={`${item.myAreaType}s${i}`}> ▼ </span>
                {`${item.name}`}
            </div>
            <div style={{
                display: item.isunfold ? 'block' : 'none'
            }}>
                {item.children}
            </div>
        </div>);
    };

    componentDidMount() {
        //多语
        let callback = json => {
            this.setState({ json: json });
            initTemplate.call(this, json, this.afterInitTemplate);
        };
        getMulti({
            moduleId: "ZoneSetting",
            domainName: "workbench",
            callback,
        });
    }
    render() {
        let { json, reRender } = this.state;
        return (
            <HotKeysModal
                maskClosable={false}
                customHeader={langCheck(
                    "ZoneSetting-000121",
                    "pages",
                    json,
                )} /* 国际化处理： 预览区*/
                // mask={false}
                visible={this.props.previewVisibel}
                onOk={this.onOkDialog}
                onCancel={this.showModalHidden}
                width="98%"
                className="viewPageTem"
                footer={null}
                fieldid="preview"
            >
                {reRender && this.createDom()}
            </HotKeysModal>
        );
    }
}

PreviewModal = createPage({})(PreviewModal);

export default connect(
    state => {
        return {
            areaList: state.zoneSettingData.areaList,
            previewData: state.zoneSettingData.previewData,
        };
    },
    { updatePreviewData },
)(PreviewModal);
